import { A as emberA } from '@ember/array';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { equal } from '@ember/object/computed';
import Model, { attr, belongsTo } from '@ember-data/model';

export default class ClientAccessModel extends Model {
  @belongsTo('base-client', { polymorphic: true, async: false, inverse: null }) client;
  @attr() accessStatus;
  @attr('boolean') eulaAgreementAccepted;
  @attr('boolean') termsOfServiceAgreementAccepted;
  @attr('boolean') privacyPolicyAgreementAccepted;
  @equal('accessStatus', 'otp_pending') isOtpPending;
  @equal('accessStatus', 'password_pending') isPasswordPending;

  get clientType() {
    return this.client.constructor.modelName;
  }

  static fieldsFor(_context) {
    let fields = emberA();
    this.fields.forEach((_, v) => fields.pushObject(v));
    fields.removeObject('meta');
    return fields;
  }
}
